import Vue from 'vue'
import home from '@/components/home'
import cart from '@/components/cart'
import product from '@/components/product'
import checkadress from '@/components/checkout/checkadress'
import shipping from '@/components/checkout/shipping'
import payment from '@/components/checkout/payment'
import review from '@/components/checkout/review'
import complete from '@/components/checkout/complete'
import all from '@/components/all'
import vipclient from '@/components/vipclient'
import grid from '@/components/grid'
import men from '@/components/men'
import festina from '@/components/festina'
import festinadepot from '@/components/festinadepot'

import bourdima from '@/components/bourdima'
import bourdimafossil from '@/components/bourdimafossil'
import bourdimaarmani from '@/components/bourdimaarmani'
import bourdimadiesel from '@/components/bourdimadiesel'
import productref from '@/components/productref'
import bourdimaMichaelkors from '@/components/bourdimaMichaelkors'



import bourdima2 from '@/components/bourdima2'
import royal from '@/components/royal'
import police from '@/components/police'
import cerruti from '@/components/cerruti'
import promo from '@/components/promo'

import lotus from '@/components/lotus'
import versus from '@/components/versus'
import trussardi from '@/components/trussardi'
import MONTIGNAC from '@/components/MONTIGNAC'
import armani from '@/components/armani'
import nautica from '@/components/nautica'
import maserati from '@/components/maserati'
import morellato from '@/components/morellato'
import timberland from '@/components/timberland'
import michaelkors from '@/components/michaelkors'
import connectee from '@/components/connectee'
import diesel from '@/components/diesel'
import top from '@/components/top'
import fossil from '@/components/fossil'
import women from '@/components/women'
import achatmobile from '@/components/achatmobile'
import about from '@/components/about'
import achat from '@/components/achat'
import contact from '@/components/contact'
import userprofile from '@/components/userprofile'
import Router from 'vue-router'
import store from '../store'


Vue.use(Router)


//used for lazy-loaded component used it for homepage only
//const HomePage = resolve => require(['../components/home.vue'], resolve);

const router = new Router({
 // mode: 'history',
  routes: [{
      path: '/',
      name: 'default',
      component: home
    },
    {
      path: '/user',
      name: 'user',
      component: userprofile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/achat',
      name: 'achat',
      component: achat
    },
    {
      path: '/achatmobile',
      name: 'achatmobile',
      component: achatmobile
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: checkadress
    },
    {
      path: '/shipping',
      name: 'shipping',
      component: shipping
    },
    {
      path: '/all',
      name: 'all',
      component: all
    },
    {
      path: '/vipclient',
      name: 'VIPCLIENT',
      component: vipclient
    },
    {
      path: '/product:ref',
      name: 'productref',
      component: productref
    },
    {
      path: '/festinadepot',
      name: 'festinadepot',
      component: festinadepot
    },
    {
      path: '/festina',
      name: 'festina',
      component: festina
    },
    {
      path: '/bourdima',
      name: 'bourdima',
      component: bourdima
    },
    {
      path: '/promo',
      name: 'promo',
      component: promo
    },
    {
      path: '/bourdima2',
      name: 'bourdima2',
      component: bourdima2
    },
    {
      path: '/bourdimafossil',
      name: 'bourdimafossil',
      component: bourdimafossil
    },
    {
      path: '/bourdimaMichaelkors',
      name: 'bourdimaMichaelkors',
      component: bourdimaMichaelkors
    },
    {
      path: '/bourdimaarmani',
      name: 'bourdimaarmani',
      component: bourdimaarmani
    },
    {
      path: '/bourdimadiesel',
      name: 'bourdimadiesel',
      component: bourdimadiesel
    },
    {
      path: '/armani',
      name: 'armani',
      component: armani
    },
    {
      path: '/maserati',
      name: 'maserati',
      component: maserati
    },
    {
      path: '/nautica',
      name: 'nautica',
      component: nautica
    },
     {
      path: '/morellato',
      name: 'morellato',
      component: morellato
    },
    {
      path: '/timberland',
      name: 'timberland',
      component: timberland
    },
    {
      path: '/productref/:ref',
      name: 'productrefd',
      component: productref
    },
    {
      path: '/royal',
      name: 'royal',
      component: royal
    },
    {
      path: '/diesel',
      name: 'diesel',
      component: diesel
    },
    {
      path: '/top',
      name: 'top',
      component: top
    },
    {
      path: '/cerruti',
      name: 'cerruti',
      component: cerruti
    },
    {
      path: '/lotus',
      name: 'lotus',
      component: lotus
    },
     {
      path: '/versus',
      name: 'versus',
      component: versus
    },
     {
      path: '/trussardi',
      name: 'trussardi',
      component: trussardi
    },
     {
      path: '/MONTIGNAC',
      name: 'MONTIGNAC',
      component: MONTIGNAC
    },
    {
      path: '/fossil',
      name: 'fossil',
      component: fossil
    },
    {
      path: '/michaelkors',
      name: 'michaelkors',
      component: michaelkors
    },
    {
      path: '/connectee',
      name: 'connectee',
      component: connectee
    },
    {
      path: '/men',
      name: 'men',
      component: men
    },
    {
      path: '/women',
      name: 'women',
      component: women
    },
    {
      path: '/payment',
      name: 'payment',
      component: payment
    },
    {
      path: '/review',
      name: 'review',
      component: review
    },
    {
      path: '/complete',
      name: 'complete',
      component: complete
    },
    {
      path: '/cart',
      name: 'cart',
      component: cart
    },
    {
      path: '/product',
      name: 'product',
      component: product
    },
    {
      path: '/grid',
      name: 'grid',
      component: grid
    }
  ],
  //linkActiveClass: "active",
  linkExactActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const userauth = JSON.parse(localStorage.getItem('auth'));
  console.log(userauth);
  if (requiresAuth && !userauth) {
    next('/');
  } else {
    next();
  }
});

export default router;

/*export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'default',
      component: home
    },
    {
      path: '/user',
      name: 'user',
      component: userprofile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/about',
      name: about,
      component: about
    },
    {
      path: '/contact',
      name: contact,
      component: contact
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: checkadress
    },
    {
      path: '/shipping',
      name: 'shipping',
      component: shipping
    },
    {
      path: '/all',
      name: 'all',
      component: all
    },
    {
      path: '/men',
      name: 'men',
      component: men
    },
    {
      path: '/women',
      name: 'women',
      component: women
    },
    {
      path: '/payment',
      name: 'payment',
      component: payment
    },
    {
      path: '/review',
      name: 'review',
      component: review
    },
    {
      path: '/complete',
      name: 'complete',
      component: complete
    },
    {
      path: '/cart',
      name: 'cart',
      component: cart
    },
    {
      path: '/product',
      name: 'product',
      component: product
    },
    {
      path: '/grid',
      name: 'grid',
      component: grid
    }
  ],
  //linkActiveClass: "active",
  linkExactActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }*/



// WEBPACK FOOTER //
// ./src/router/index.js